<template>
    <div>
        <div style="color: #757575; margin-bottom: 4px;">Note</div>
        <textarea
            :value="form.text"
            @input="form.text = $event.target.value"
            rows="10"
            class="note-textarea"
        ></textarea>
    </div>
</template>

<script>
export default {
    name: "EditTestNoteForm",
	props: {
		form: {
		    required: true
	    }
    },
}
</script>

<style scoped>
.note-textarea {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 12px;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    resize: vertical;
    outline: none;
    line-height: 1.5;
}

.note-textarea:focus {
    border-color: rgb(51, 211, 255);
    box-shadow: 0 0 0 1px rgb(51, 211, 255);
}
</style>
